export const preventDefault = callBack => e => {
  e.preventDefault();
  callBack();
};
